module.exports = __webpack_public_path__ + "static/media/Rai_Italia.9ff0c9f8.png";